import axios from 'axios';
import { objectSelector } from 'theme/utils';
const $A = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/app`);
const $U = require(`plugins/${process.env.REACT_APP_BRAND_CODE}/platformConfigs/integrationMaps/urls`);

const _axios = axios.create({
  baseURL: $U.BASE_URL,
  xsrfCookieName: 'store_csrftoken',
  xsrfHeaderName: 'X-Store-CSRFToken',
});
const responseLanguage = objectSelector($A, 'RESPONSE_LANGUAGE', 'en-us');

export const request = (requestObject) => {
  requestObject.headers = {
    'accept-language': responseLanguage,
    'X-CSRFToken': getCookie('csrftoken'),
    ...requestObject.headers,
  };

  return _axios(requestObject);
};

export const getCookie = (name) => {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    let cookies = document.cookie.split(';');
    cookies.forEach((el) => {
      let cookie = el.trim();

      if (cookie.substring(0, name.length + 1) === name + '=') {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
      }
    });
  }
  return cookieValue;
};

export const setCookie = (cname, cvalue, exdays) => {
  let d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + d.toUTCString();
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
};



// WEBPACK FOOTER //
// ./src/axios/request.js